import api from './client'
import type { TimeLog, TimeLogStatus, WorkType } from '../types'

type TimeLogPayload = {
  userId?: string
  workType: WorkType
  status: TimeLogStatus
  hours: number
  progressPercent?: number
  progressNotes?: string
  completedDetails?: string
  loggedDate: string
  internalNote?: {
    content: string
  }
}

type TimeLogUpdatePayload = {
  workType?: WorkType
  status?: TimeLogStatus
  hours?: number
  progressPercent?: number | null
  progressNotes?: string | null
  completedDetails?: string | null
  loggedDate?: string
  internalNote?: {
    content: string
  }
}

export const timeLogsApi = {
  listTimeLogs: (issueId: string) =>
    api.get<{ data: TimeLog[] }>(`/issues/${issueId}/time-logs`),

  createTimeLog: (issueId: string, data: TimeLogPayload) =>
    api.post<{ data: TimeLog }>(`/issues/${issueId}/time-logs`, data),

  updateTimeLog: (issueId: string, timeLogId: string, data: TimeLogUpdatePayload) =>
    api.put<{ data: TimeLog }>(`/issues/${issueId}/time-logs/${timeLogId}`, data),

  deleteTimeLog: (issueId: string, timeLogId: string) =>
    api.delete(`/issues/${issueId}/time-logs/${timeLogId}`),
}
